import Chart from "react-apexcharts";

const SparklineChart = ({ data = [], color = "#3b82f6" }) => {
  if (!Array.isArray(data) || data.length === 0) return null;
  const series = [
    {
      data: data.map((d) => Number(d.value) || 0),
    },
  ];
  const options = {
    chart: {
      type: "area",
      sparkline: { enabled: true },
      animations: { enabled: false },
    },
    stroke: { curve: "smooth", width: 2 },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.35,
        opacityTo: 0.05,
        stops: [0, 100],
      },
    },
    colors: [color],
    tooltip: { enabled: false },
  };
  return <Chart options={options} series={series} type="area" height="100%" />;
};

export default SparklineChart;
